import React from 'react';
import { useLocation } from 'react-router-dom';
import LocalizedLink from '../atoms/LocalizedLink';

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  exact?: boolean;
}

const NavLink: React.FC<NavLinkProps> = ({
  to,
  children,
  className = '',
  exact = false,
}) => {
  const location = useLocation();
  const isActive = exact 
    ? location.pathname === to 
    : location.pathname.startsWith(to.split('#')[0]);

  // For dropdown menu items that use anchor links
  const baseStyles = to.includes('#') && !className.includes('block')
    ? 'block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-tlc-navy'
    : `
      inline-flex items-center px-3 py-2 text-sm font-medium border-b-2 
      ${isActive 
        ? 'border-tlc-gold text-tlc-navy' 
        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'}
    `;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // If it's a regular link (no hash), scroll to top
    if (!to.includes('#') && location.pathname !== to) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
    }
  };

  return (
    <LocalizedLink
      to={to}
      className={`${baseStyles} ${className}`}
      aria-current={isActive ? 'page' : undefined}
      onClick={handleClick}
    >
      {children}
    </LocalizedLink>
  );
};

export default NavLink; 